import { Button } from "@/modern/components/ui/button";
import { Link2, Loader2 } from "lucide-react";
import { useMyMediaContext } from "../context/MyMediaContext";
import { BaseModalFooter } from "@/react/components/editors/base/BaseModalFooter";

export const AssignmentFooter = () => {
  const { selectedFiles, entityRecord, assignFilesToEntity, isAssigning } = useMyMediaContext();

  const selectedCount = selectedFiles.size;
  const hasSelection = selectedCount > 0;
  const hasEntity = entityRecord !== null;

  const handleAssign = async () => {
    if (!hasSelection || !hasEntity || !entityRecord) return;

    const fileIds = Array.from(selectedFiles);
    await assignFilesToEntity(fileIds, entityRecord);
  };

  if (!hasEntity || !hasSelection) {
    return null;
  }

  const entityName = entityRecord?.name || "entity";

  return (
    <BaseModalFooter>
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">
            {selectedCount} file{selectedCount !== 1 ? "s" : ""} selected
          </span>
        </div>
        <Button
          onClick={handleAssign}
          disabled={!hasSelection || isAssigning}
          size='sm'
        >
          {isAssigning ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Linking...
            </>
          ) : (
            <>
              <Link2 className="h-4 w-4" />
              Link to {entityName}
            </>
          )}
        </Button>
      </div>
    </BaseModalFooter>
  );
};
